import { styled } from 'styled-components';

import TextField from 'components/TextField';

export const FormElement = styled(TextField)`
    && {
        display: inline;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: -1;
        width: 0;
        height: 0;
    }
`;
